import { inject } from "@angular/core";
import { CanActivateFn } from "@angular/router";
import { Store } from "@ngrx/store";
import { take } from "rxjs";
import { RootState } from "../ngrx/root.model";
import { AuthServiceDataToken } from "../constants/session.constants";

export function isLoggedIn(): CanActivateFn {
  return () => {
    const store: Store<RootState> = inject(Store);
    let loggedIn = false;

    store.pipe(take(1)).subscribe((state: RootState) => {
      loggedIn = state.app.userLoggedIn;
    });

    if (!loggedIn) {
      const authData = sessionStorage.getItem(AuthServiceDataToken);

      if (authData) {
        loggedIn = true;
      }
    }

    return loggedIn;
  };
}
